/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface FlightBookingContact
 */
export interface FlightBookingContact {
    /**
     *
     * @type {string}
     * @memberof FlightBookingContact
     */
    email: string;
    /**
     *
     * @type {string}
     * @memberof FlightBookingContact
     */
    phone: string;
}

/**
 * Check if a given object implements the FlightBookingContact interface.
 */
export function instanceOfFlightBookingContact(value: object): value is FlightBookingContact {
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    return true;
}

export function FlightBookingContactFromJSON(json: any): FlightBookingContact {
    return FlightBookingContactFromJSONTyped(json, false);
}

export function FlightBookingContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): FlightBookingContact {
    if (json == null) {
        return json;
    }
    return {

        'email': json['email'],
        'phone': json['phone'],
    };
}

export function FlightBookingContactToJSON(json: any): FlightBookingContact {
    return FlightBookingContactToJSONTyped(json, false);
}

export function FlightBookingContactToJSONTyped(value?: FlightBookingContact | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'email': value['email'],
        'phone': value['phone'],
    };
}
